import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {User} from 'main/stores/users';
import {AttachedDocument} from '../documents';

class OfferSummary extends DomainObject {
  firstName;
  lastName;
  expiresAt;
  sentAt;
  acceptedAt;
  revokedAt;
  hiredAt;
  email;
  revokeReason;
  viewStatus;
  viewStatusUpdatedAt;
  candidateId;
  attachments;
  renderedContent;
  locale;
  createdByUser;
  isExpired;
  isAccepted;
  isRevoked;

  _relations = {
    _dates: ['expiresAt', 'acceptedAt', 'revokedAt', 'hiredAt'],
    attachments: [AttachedDocument],
    offerDocument: AttachedDocument,
    createdByUser: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      firstName: observable,
      lastName: observable,
      expiresAt: observable,
      sentAt: observable,
      acceptedAt: observable,
      revokedAt: observable,
      hiredAt: observable,
      email: observable,
      revokeReason: observable,
      viewStatus: observable,
      viewStatusUpdatedAt: observable,
      candidateId: observable,
      attachments: observable,
      renderedContent: observable,
      locale: observable,
      createdByUser: observable,
      isExpired: observable,
      isAccepted: observable,
      isRevoked: observable,
      name: computed
    });

    this.merge(other);
  }

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }
}

export default OfferSummary;
